export enum EsusDetailMode {
  VISUALIZE = 0,
  EDIT = 1,
  APPEND = 2,
}
